import React, { FC } from 'react';

import translate from '../../../../../i18n/translate';
import ButtonControl from '../ButtonControl';

type Props = {
  isActive: boolean;
  onClick: () => void;
};

/**
 * The button for adding a numbered list
 *
 * @param props          The props passed to the component
 * @param props.isActive Whether the control is active
 * @param props.onClick  Button click callback
 * @returns              The component itself
 */
const ButtonStyleListNumbers: FC<Props> = props => {
  const label = translate('COMPOSE__LIST__NUMBERS');
  return <ButtonControl iconName="formatList" label={label} {...props} />;
};

export default ButtonStyleListNumbers;
